import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// GA4 is hardcoded directly in public/index.html <head> (measurement ID
// G-8H1FR0C1RY is a public frontend identifier, no need to indirect it).
//
// Microsoft Clarity is still runtime-injected from CLARITY_PROJECT_ID env var
// so ops can rotate the project without a rebuild. Silent skip if unset.

function injectClarity(id) {
  if (!id || document.querySelector('script[data-analytics="clarity"]')) return;
  const s = document.createElement("script");
  s.setAttribute("data-analytics", "clarity");
  s.text = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, 'clarity', 'script', '${id}');
  `;
  document.head.appendChild(s);
}

export default function Analytics() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/analytics-config`, { timeout: 8000 });
        if (cancelled) return;
        injectClarity(data?.clarity_project_id);
      } catch (_) {
        // Silent — analytics is best-effort, must never break the app.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return null;
}
